import { useNavigate } from "react-router-dom";
import { MoreVertical, PenTool, Eye, Trash2, Library, Check } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSub, DropdownMenuSubTrigger, DropdownMenuSubContent, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";

export const StatusBadge = ({ b }) => {
  if (b.status === "processing") return <span className="font-mono text-[11px] text-[#3D3DF0]">PROCESSING {b.progress?.done}/{b.progress?.total || "?"}</span>;
  if (b.status === "failed") return <span className="font-mono text-[11px] text-[#A62B8A]">FAILED</span>;
  if (b.published_version) return <span className="font-mono text-[11px] text-[#5FA82E]">PUBLISHED v1.{b.published_version - 1}</span>;
  return <span className="font-mono text-[11px] text-[#64748B]">DRAFT</span>;
};

export const BookMenu = ({ b, shelves, onDelete, onMove }) => {
  const navigate = useNavigate();
  const targets = [{ shelf_id: "", name: "Unsorted" }, ...shelves];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="rounded p-1 text-[#64748B] hover:bg-[#E2E8F3] hover:text-[#0F172A]" data-testid={`book-menu-${b.book_id}`}><MoreVertical className="h-4 w-4" /></DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="border-[#DCE3EE] bg-[#EEF2F8]">
        <DropdownMenuItem onClick={() => navigate(`/editor/${b.book_id}`)} data-testid={`book-edit-${b.book_id}`}><PenTool className="mr-2 h-4 w-4" />Edit</DropdownMenuItem>
        {b.published_version && <DropdownMenuItem onClick={() => window.open(`/read/${b.slug}`, "_blank")} data-testid={`book-read-${b.book_id}`}><Eye className="mr-2 h-4 w-4" />Open reader</DropdownMenuItem>}
        <DropdownMenuSub>
          <DropdownMenuSubTrigger data-testid={`book-move-${b.book_id}`}><Library className="mr-2 h-4 w-4" />Move to shelf</DropdownMenuSubTrigger>
          <DropdownMenuSubContent className="border-[#DCE3EE] bg-[#EEF2F8]">
            {targets.map((s) => (
              <DropdownMenuItem key={s.shelf_id || "unsorted"} onClick={() => onMove(b.book_id, s.shelf_id)} data-testid={`book-move-${b.book_id}-to-${s.shelf_id || "unsorted"}`}>
                <Check className={`mr-2 h-4 w-4 ${(b.shelf_id || "") === s.shelf_id ? "opacity-100 text-[#3D3DF0]" : "opacity-0"}`} />{s.name}
              </DropdownMenuItem>
            ))}
          </DropdownMenuSubContent>
        </DropdownMenuSub>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => onDelete(b)} className="text-[#A62B8A]" data-testid={`book-delete-${b.book_id}`}><Trash2 className="mr-2 h-4 w-4" />Delete</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
